import { Locale, format } from 'date-fns';
import allLocales from '../constants/locale.constants';
import useSitecoreContext from './useSitecoreContext';

export const getUTCDate = (dateString: string): Date => {
  const date = new Date(dateString);
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};

export const getFormattedDate = (date: Date, dateFormat: string, locale?: Locale) => {
  return format(date, dateFormat, locale && { locale });
};

export default function useFormatDate(dateString?: string): string | undefined {

  if (!dateString) return dateString;

  const {sitecoreContext} = useSitecoreContext();
  const defaultDateFormat = 'dd MMMM yyyy';
  const { dateFormat = defaultDateFormat, dateLocal } = sitecoreContext?.regionalSettings || {};
  const utcDate = getUTCDate(dateString);
  const locale = allLocales[dateLocal];
  let formattedDate: string;

  try {
    formattedDate = getFormattedDate(new Date(utcDate), dateFormat, locale);
  } catch (error) {
    formattedDate = getFormattedDate(new Date(utcDate), defaultDateFormat, locale);
  }

  return formattedDate;
}
